/* eslint-disable import/named */
import { connect } from 'react-redux';

import Sidebar from '../components/Sidebar';

const mapStateToProps = (state) => {
  const { menuActived, menuDesktopActived } = state.action;

  return {
    menuActived,
    menuDesktopActived,
  };
};

export default connect(mapStateToProps)(Sidebar);
